import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer, toast } from "react-toastify";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";
import FeeSystemMenu from "./FeeSystemMenu";
import config from "../../Config";

const GenerateChallan = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [UserName] = useState(localStorage.getItem("UserName") || "");

  const [RegistrationNo, setRegistrationNo] = useState("");
  const [StudentId, setStudentId] = useState("");
  const [studentInfo, setStudentInfo] = useState(null);
  const [studentConcessions, setStudentConcessions] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [SelectedMonth, setSelectedMonth] = useState("");
  const [FYear, setFYear] = useState("");
  const [ChallanDueDate, setChallanDueDate] = useState("");
  const [AddTransportFee, setAddTransportFee] = useState(false);
  const [BusTotalDays, setBusTotalDays] = useState(0);
  const [BusAvailDays, setBusAvailDays] = useState(0);
  const [loading, setLoading] = useState(false);
  const [generatedChallan, setGeneratedChallan] = useState("");

  const location = useLocation();
  const hasAutoSearched = useRef(false);

  useEffect(() => {
    document.title = "Generate Challan";

    // Read URL parameters
    const params = new URLSearchParams(location.search);
    const urlStudentId = params.get("Student_ID");
    const urlMonth = params.get("Month");
    const urlYear = params.get("Year");

    // Set month and year if provided, or default to current month/year
    const now = new Date();
    setSelectedMonth(urlMonth || (now.getMonth() + 1).toString());
    setFYear(urlYear || now.getFullYear().toString());

    // If Student_ID is provided in URL, auto-populate and search
    if (urlStudentId && !hasAutoSearched.current) {
      hasAutoSearched.current = true;
      setStudentId(urlStudentId);
      // Trigger auto-search after state is set
      performAutoSearch(urlStudentId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const performAutoSearch = async (studentIdValue) => {
    setSearchLoading(true);
    try {
      const detailResp = await axios({
        method: "post",
        url: config.base_url + "Student/GetStudentByID",
        headers: { "Content-Type": "application/json" },
        data: {
          AccessKey,
          UserID,
          MemberType,
          ID: studentIdValue,
        },
      });

      if (detailResp.data.status_code === 1 && detailResp.data.Student) {
        setStudentInfo(detailResp.data.Student);
        setStudentConcessions(detailResp.data.ListOfMultiConcessions || []);
        toast.success("Student loaded successfully!", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(detailResp.data.status_message || "Student not found.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setStudentInfo(null);
    setStudentConcessions([]);
    setGeneratedChallan("");

    if (!RegistrationNo && !StudentId) {
      toast.error("Please enter registration number or student ID.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setSearchLoading(true);
    try {
      let studentIdValue = StudentId;
      if (!studentIdValue && RegistrationNo) {
        const regResp = await axios({
          method: "post",
          url: config.base_url + "Student/GetStudentByRegistrationNo",
          headers: { "Content-Type": "application/json" },
          data: {
            AccessKey,
            UserID,
            MemberType,
            Registration_No: RegistrationNo,
          },
        });
        if (regResp.data.status_code !== 1 || !regResp.data.Student) {
          toast.error(regResp.data.status_message || "Student not found.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setSearchLoading(false);
          return;
        }
        studentIdValue = regResp.data.Student.Student_ID;
      }

      const detailResp = await axios({
        method: "post",
        url: config.base_url + "Student/GetStudentByID",
        headers: { "Content-Type": "application/json" },
        data: {
          AccessKey,
          UserID,
          MemberType,
          ID: studentIdValue,
        },
      });

      if (detailResp.data.status_code === 1 && detailResp.data.Student) {
        setStudentInfo(detailResp.data.Student);
        setStudentConcessions(detailResp.data.ListOfMultiConcessions || []);
      } else {
        toast.error(detailResp.data.status_message || "Student not found.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setGeneratedChallan("");

    if (!studentInfo || !SelectedMonth || !FYear) {
      toast.error("Please select student, month and year.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "ADLedger/GenerateChallanForStudent",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        UserName,
        Registration_No: studentInfo.Registration_No || "",
        Student_ID: studentInfo.Student_ID,
        SelectedMonth: parseInt(SelectedMonth),
        FYear: parseInt(FYear),
        Challan_DueDate: ChallanDueDate ? `${ChallanDueDate}T00:00:00` : null,
        AddTransportFee,
        BusTotalDays: parseInt(BusTotalDays) || 0,
        BusAvailDays: parseInt(BusAvailDays) || 0,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setGeneratedChallan(response.data.Challan_No || "");
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/FeeSystem/FeeSystemDashboard">Fee System</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Generate Challan
                  </li>
                </ol>
              </nav>
              <div className="page-title">Generate Challan</div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group mb-3">
                      <label>Registration No</label>
                      <input
                        type="text"
                        className="form-control"
                        value={RegistrationNo}
                        onChange={(e) => setRegistrationNo(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-3">
                      <label>Student ID</label>
                      <input
                        type="text"
                        className="form-control"
                        value={StudentId}
                        onChange={(e) => setStudentId(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 d-flex align-items-end">
                    <button
                      type="button"
                      className="button button-outline-primary w-100 mb-3"
                      onClick={handleSearch}
                      disabled={searchLoading}
                    >
                      {searchLoading ? "Searching..." : "Search Student"}
                    </button>
                  </div>
                </div>

                {studentInfo && (
                  <div className="card mb-3">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div><strong>Name:</strong> {studentInfo.Student_Name}</div>
                          <div><strong>Father:</strong> {studentInfo.Father_Name}</div>
                          <div>
                            <strong>Registration No:</strong>{" "}
                            {studentInfo.Registration_No || "New Registration"}
                          </div>
                          <div><strong>Student ID:</strong> {studentInfo.Student_ID}</div>
                        </div>
                        <div className="col-md-4">
                          <div>
                            <strong>Class/Section:</strong>{" "}
                            {studentInfo.SelectedClass?.Class_Name || ""}
                            {studentInfo.SelectedSection?.Section_Name
                              ? ` (${studentInfo.SelectedSection.Section_Name})`
                              : ""}
                          </div>
                          <div>
                            <strong>Wing:</strong>{" "}
                            {studentInfo.SelectedClass?.SelectedWing?.Wing_Name || ""}
                          </div>
                          <div>
                            <strong>Transport:</strong>{" "}
                            {studentInfo.Current_Route_Id || "N/A"}
                          </div>
                          <div>
                            <strong>Transport Fee Type:</strong>{" "}
                            {studentInfo.Transport_Fee_Type || "N/A"}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div>
                            <strong>Concessions:</strong>{" "}
                            {studentConcessions.length > 0
                              ? studentConcessions
                                  .map(
                                    (c) =>
                                      c.Concession_Rule_Name ||
                                      c.Concession_Rule_Code ||
                                      c.Concession_Rule_ID
                                  )
                                  .join(", ")
                              : "N/A"}
                          </div>
                          <div>
                            <strong>Concession Amount:</strong>{" "}
                            {studentInfo.Concession_Amount || 0}
                          </div>
                          <div>
                            <strong>Concession Remarks:</strong>{" "}
                            {studentInfo.Concession_Remarks || ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group mb-3">
                      <label>Month</label>
                      <select
                        className="form-select"
                        value={SelectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        required
                      >
                        <option value="">Please Select</option>
                        <MonthsDropDown />
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-3">
                      <label>Year</label>
                      <select
                        className="form-select"
                        value={FYear}
                        onChange={(e) => setFYear(e.target.value)}
                        required
                      >
                        <option value="">Please Select</option>
                        <YearsDropDown />
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-3">
                      <label>Challan Due Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={ChallanDueDate}
                        onChange={(e) => setChallanDueDate(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-check mt-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="addTransportFee"
                        checked={AddTransportFee}
                        onChange={(e) => setAddTransportFee(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="addTransportFee">
                        Add Transport Fee
                      </label>
                    </div>
                  </div>
                </div>

                {AddTransportFee && (
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group mb-3">
                        <label>Bus Total Days</label>
                        <input
                          type="number"
                          className="form-control"
                          value={BusTotalDays}
                          onChange={(e) => setBusTotalDays(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-3">
                        <label>Bus Avail Days</label>
                        <input
                          type="number"
                          className="form-control"
                          value={BusAvailDays}
                          onChange={(e) => setBusAvailDays(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="text-end">
                  <button type="submit" className="button button-primary" disabled={loading}>
                    {loading ? "Generating..." : "Generate Challan"}
                  </button>
                </div>
              </form>

              {generatedChallan && (
                <div className="alert alert-success mt-3">
                  Challan generated: <strong>{generatedChallan}</strong>
                  <div className="mt-2">
                    <NavLink
                      to={`/Students/PrintVoucher/?ChallanNos=${encodeURIComponent(
                        generatedChallan
                      )}`}
                      target="_blank"
                      className="button button-primary button-sm"
                    >
                      Print Challan
                    </NavLink>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateChallan;
